import { WagmiProvider as NativeWagmiProvider } from 'wagmi'
import { config } from './config'

const WagmiProvider = ({ children }) => {
  return <NativeWagmiProvider config={config}>{children}</NativeWagmiProvider>
}

export default WagmiProvider
